import { render, staticRenderFns } from "./Evals.vue?vue&type=template&id=674b90b5&scoped=true&"
import script from "./Evals.vue?vue&type=script&lang=js&"
export * from "./Evals.vue?vue&type=script&lang=js&"
import style0 from "./Evals.vue?vue&type=style&index=0&id=674b90b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b90b5",
  null
  
)

export default component.exports